var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M625.091,178.286l0,-136.889",
    style: {
      fill: "none",
      stroke: "#3f40cc",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.091,1208.37l0,-136.889",
    style: {
      fill: "none",
      stroke: "#3f40cc",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.93,624.643l136.89,0",
    style: {
      fill: "none",
      stroke: "#3f40cc",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.888,624.643l136.889,0",
    style: {
      fill: "none",
      stroke: "#3f40cc",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.213,211.108l96.796,96.796",
    style: {
      fill: "none",
      stroke: "#3f40cc",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.641,941.536l96.796,96.796",
    style: {
      fill: "none",
      stroke: "#3f40cc",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.7,940.132l-96.796,96.795",
    style: {
      fill: "none",
      stroke: "#3f40cc",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.5,211.335l-96.795,96.795",
    style: {
      fill: "none",
      stroke: "#3f40cc",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.187,401.691c122.802,0 222.502,99.7 222.502,222.503c0,122.802 -99.7,222.502 -222.502,222.502c-122.803,0 -222.503,-99.7 -222.503,-222.502c-0,-122.803 99.7,-222.503 222.503,-222.503Zm-0,0.278c122.649,0 222.224,99.576 222.224,222.225c-0,122.649 -99.575,222.224 -222.224,222.224c-122.65,0 -222.225,-99.575 -222.225,-222.224c0,-122.649 99.575,-222.225 222.225,-222.225Z",
    style: {
      fill: "#ff006f",
      stroke: "#3f40cc",
      strokeWidth: "37.5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.e6fb3de6f27cf3c26bde4f0ad4296772.svg";
export { ForwardRef as ReactComponent };